import React from 'react';
import { services } from '../../mock';
import { Sparkles, Microscope, HeartHandshake, ShieldCheck, Droplet } from 'lucide-react';

const icons = [Sparkles, Microscope, HeartHandshake, ShieldCheck, Droplet];

const Services = () => {
  return (
    <section id="services" className="py-20 lg:py-28 bg-[var(--brand-cream-2)]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl reveal">
          <div className="text-xs uppercase tracking-[0.24em] text-[var(--brand-gold)] mb-4">Proactive Health Solutions</div>
          <h2 className="font-serif text-4xl lg:text-6xl text-green tracking-tight leading-[1.04]">
            Medical innovation, <em className="italic">delivered with</em> trust and clarity.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-5 gap-4">
          {services.map((s, i) => {
            const Ic = icons[i % icons.length];
            return (
              <div
                key={s.title}
                className="reveal card-hover rounded-2xl p-6 border border-[rgba(31,58,46,0.08)] bg-[var(--brand-cream)] flex flex-col h-full"
              >
                <div className="h-11 w-11 rounded-full grid place-items-center bg-[var(--brand-green)] text-[var(--brand-cream)] mb-4">
                  <Ic size={18} strokeWidth={1.6} />
                </div>
                <div className="font-serif text-xl text-green leading-tight">{s.title}</div>
                <p className="mt-2 text-sm text-[var(--brand-mute)] leading-relaxed flex-1">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
